//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CsysReferenceType",1,0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"ExtentType",1,0],[0,"InnerOuterType",1,0],[0,"Name",1,0],[1,"SelectedSide1",0,"SelectNXObjectList",0],[1,"SelectedSide2",0,"SelectNXObjectList",0],[0,"Side1NormalVectorI",1,0],[0,"Side1NormalVectorJ",1,0],[0,"Side1NormalVectorK",1,0],[0,"Side1PointX",1,0],[0,"Side1PointY",1,0],[0,"Side1PointZ",1,0],[0,"Side2NormalVectorI",1,0],[0,"Side2NormalVectorJ",1,0],[0,"Side2NormalVectorK",1,0],[0,"Side2PointX",1,0],[0,"Side2PointY",1,0],[0,"Side2PointZ",1,0],[0,"Width",1,0]],[[[],"UpdateParams",{},0,0]],[]];
SPLM.CAM.InspectionParplnFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionParplnFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;